import { FullscreenModal } from "shared";
import { UserType } from "types/UsersTypes";
import { CompanyAddress } from "./Components";
import { useGetAddress } from "hooks/addresses";

interface EditAddressDataModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  user: UserType | null;
}

const EditAddressDataModal: React.FC<EditAddressDataModalProps> = ({
  isOpen,
  onClose,
  user,
}) => {
  const { data } = useGetAddress();
  return (
    <FullscreenModal isOpen={isOpen} onClose={onClose}>
      <h2 className="fullscreen-modal__header">
        {data ? "Edycja danych adresowych" : "Dodawanie danych adresowych"}
      </h2>
      <p className="fullscreen-modal__subtitle">
        Pola „Nazwa firmy” i „NIP” są opcjonalne – wypełnij je, jeśli chcesz
        dodać dane firmowe. Jeśli chcesz dodać dane osobowe, możesz pominąć te
        pola.
      </p>

      <CompanyAddress onClose={onClose} user={user} />
    </FullscreenModal>
  );
};

export default EditAddressDataModal;
